export default class ExistentUserException extends Error {
  public constructor(message?: string) {
    super(message ?? 'Usuário já existente');
    this.name = 'ExistentUserException';
  }
}
